import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const leveleldConfig: TSPConfig = {
  key: 'leveleld',
  name: 'LevelELD',
  imageName: 'leveleld',
  category: TSPCategory.API_KEY,
  helpText:
    'Please request an API key from LevelELD support or your representative, then enter it below.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default leveleldConfig;
